import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const useEventsListingCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        EventsListingPage: {
             heroBackground: {
            small_url: {
              url: '/imgs/Rebranding/events/hero_sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/events/hero_md.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/events/hero_lg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/events/hero_xl.jpg',
            },
            alt: 'deals Page Background',
          },
          patternBackground: {
            small_url: {
              url: '/imgs/Rebranding/petterns/asphalt_sm.png',
            },
            medium_url: {
              url: '/imgs/Rebranding/petterns/asphalt_sm.png',
            },
            large_url: {
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            alt: 'pattern Background',
          },
          motorcycleEvents: t('events_listing:motorcycle_events'),
          heroSubtitle: t('events_listing:hero_sub_title'),
          locationSelectedLabel: t('events_listing:location_selected'),
          eventTypeSelectedLabel: t('events_listing:event_type_selected'),
          locationTypeSelectedLabel: t('events_listing:location_type_selected'),
          clubEagleRiderRides: t('events_listing:club_eaglerider_rides'),
          eventCount: t('events_listing:event_count'),
          eventsCount: t('events_listing:events_count'),
         locationEvents: t('events_listing:location_events'),
          addressLabel: t('events_listing:address'),
          addressTitle: t('events_listing:address_title'),
          viewMoreEvents: t('events_listing:view_more_events'),
          eventTypeLabel: t('events_listing:event_type'),
          eventLocationLabel: t('events_listing:event_location'),
          allEventsLabel: t('events_listing:all_events'),
          allLocationsLabel: t('events_listing:all_locations'),
          eagleRiderLabel: t('events_listing:eagle_rider'),
          motorcycleEventsCapitalLetters: t('events_listing:motorcycle_events_captail_letters'),
          noEventsFoundTitle: t('events_listing:no_events_found_title'),
          noEventsFoundDesc: t('events_listing:no_events_found_desc'),
          backBtnLabel: t('events_listing:back_btn'),
        },
        EventRideCardComponent:{
          featuredLabel:t('common_event_ride_card:featured'),
          learnMoreBtnLabel:t('common_event_ride_card:learn_more'),
        }
      },
    }),
    [t],
  );

  return data;
};

export { useEventsListingCMSData };